export default __webpack_public_path__ + "static/media/two.6f3c9aab.jpeg";